import { render, staticRenderFns } from "./EsgTopBar.vue?vue&type=template&id=a87cb460&scoped=true"
import script from "./EsgTopBar.vue?vue&type=script&lang=js"
export * from "./EsgTopBar.vue?vue&type=script&lang=js"
import style0 from "./EsgTopBar.vue?vue&type=style&index=0&id=a87cb460&prod&scoped=true&lang=css"
import style1 from "./EsgTopBar.vue?vue&type=style&index=1&id=a87cb460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cb460",
  null
  
)

export default component.exports